import { css } from '@emotion/css';

import { mobileMediaQuery, nonMobileMediaQuery } from '../../constants';
import { m } from '../../motif/m';
import { FontFamily } from '../Font/fontConstants';

export const bigQuoteCss = css`
  font-size: 40px;
  line-height: 40px;
  margin-bottom: -20px;
  margin-top: -8px;
  text-align: start;
`;

export const startQuoteCss = css`
  margin-inline-start: -16px;
  text-align: start;
`;

export const endQuoteCss = css`
  margin-inline-end: -20px;
  text-align: end;
`;

export const quoteCss = css`
  padding: ${m('--spacing-xl')};
  border-radius: ${m('--border-radius-l')};

  background-color: ${m('--quote-bg-color')};
  color: ${m('--quote-fg-color')};
  box-shadow: ${m('--box-shadow-s')};
  font-family: ${m('--h5-font-family')};
  line-height: 120%;

  *[dir='rtl'] & {
    direction: rtl;
  }

  ${nonMobileMediaQuery} {
    width: 70%;
    max-width: 700px;
    font-size: ${m('--h5-desktop-font-size')};
    font-weight: ${m('--h5-desktop-font-weight')};
  }

  ${mobileMediaQuery} {
    width: 100%;
    padding: ${m('--spacing-l')};
    font-size: ${m('--h5-mobile-font-size')};
    font-weight: ${m('--h5-mobile-font-weight')};
  }
`;

export const quoteIconCss = css`
  font-family: ${FontFamily.PROGRAM_OT}, Helvetica, Tahoma, Arial, sans-serif;
  color: ${m('--action-text-active-color')};
  font-size: 150px;
  line-height: 120px;
  margin-bottom: -48px;

  ${mobileMediaQuery} {
    font-size: 120px;
    line-height: 96px;
    margin-bottom: -32px;
  }
`;

export const quoteTextCss = css`
  display: block;
  clear: both;
`;

export const longQuoteTextCss = css`
  display: block;
  clear: both;
  font-family: ${m('--font-family')};
  line-height: 120%;

  ${nonMobileMediaQuery} {
    font-size: ${m('--p1-desktop-font-size')};
    font-weight: ${m('--p1-desktop-font-weight')};
  }

  ${mobileMediaQuery} {
    font-size: ${m('--p1-mobile-font-size')};
    font-weight: ${m('--p1-mobile-font-weight')};
  }
`;

export const imageButtonContainerCss = css`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  max-height: 98px;
  margin-bottom: ${m('--spacing-l')};
  margin-top: ${m('--spacing-l')};

  /* Override default button padding for logo alignment */
  button {
    padding: 0;
  }
`;

export const quoteIconContainerCss = css`
  display: flex;
  justify-content: flex-start;

  ${mobileMediaQuery} {
    justify-content: center;
  }
`;

export const authorCss = css`
  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  text-align: end;

  ${nonMobileMediaQuery} {
    font-size: ${m('--quote-author-desktop-font-size')};
    font-weight: ${m('--quote-author-desktop-font-weight')};
  }

  ${mobileMediaQuery} {
    font-size: ${m('--quote-author-mobile-font-size')};
    font-weight: ${m('--quote-author-mobile-font-weight')};
  }
`;

export const authorWithoutLogoCss = css`
  ${authorCss}
  margin-top: ${m('--spacing-l')};
`;

export const logoWithoutAuthorCss = css`
  ${imageButtonContainerCss}
`;

export const quoteContainerCss = css`
  ${nonMobileMediaQuery} {
    flex-direction: row;
  }

  ${mobileMediaQuery} {
    flex-direction: column;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* Force LTR for component layout, but text inside will still respect RTL */
  direction: ltr;
`;

export const quoteMediaContainerCss = css`
  transform: rotate(-2deg) translateX(8px);
  border-radius: ${m('--border-radius-xl')};
  overflow: hidden;
  box-shadow: ${m('--box-shadow-s')};

  ${nonMobileMediaQuery} {
    width: 30%;
    height: 100%;
    min-width: 280px;
    max-width: 320px;
  }

  ${mobileMediaQuery} {
    width: 90%;
    max-width: 360px;
    transform: rotate(-2deg) translateY(16px);
  }
`;

export const imageCss = css`
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center;
  width: 100%;
`;

export const videoCss = css`
  height: 100%;
  object-fit: cover;
  object-position: center;
  width: 100%;
`;
